// modules/inicio/components/CardModule.js
// Tarjeta de acceso a una estrategia en el Home.

export default function CardModule({ title, icon, desc, color, onClick, bloqueado, etiqueta }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`modulo-card ${bloqueado ? "bloqueado" : ""}`}
      style={{ "--modulo-color": color }}
      aria-disabled={bloqueado || undefined}
    >
      {etiqueta && <span className="modulo-etiqueta">{etiqueta}</span>}
      <span className="modulo-icono" aria-hidden="true">{icon}</span>
      <span style={{ minWidth: 0 }}>
        <span className="modulo-titulo d-block">{title}</span>
        <span className="modulo-desc d-block">{desc}</span>
      </span>
      {!bloqueado && <span className="modulo-flecha" aria-hidden="true">›</span>}
    </button>
  );
}
